window.TV2 = window.TV2 || {};

window.TV2.initArticleHeaderFigcaption = () => {
  const articleMedia = document.querySelector('.articleheader__media');
  const figcaption = articleMedia.querySelector(".articleheader__figcaption");
  const caption = articleMedia.querySelector(".articleheader__caption");
  const buttonElement = articleMedia.querySelector(".articleheader__button");

  if (buttonElement) {
    buttonElement.addEventListener("click", () => {
      figcaption.classList.add("articleheader__figcaption--open");
      caption.classList.add("articleheader__caption--open");
      buttonElement.classList.add("articleheader__button--hide");
    });
  }
};
